"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ContentHelpfulnessPreview = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _topicHelpfulness = _interopRequireDefault(require("../../preact-components/topic-helpfulness/topicHelpfulness"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ContentHelpfulnessPreview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ContentHelpfulnessPreview, _Component);

  var _super = _createSuper(ContentHelpfulnessPreview);

  function ContentHelpfulnessPreview(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ContentHelpfulnessPreview);
    _this = _super.call(this, props);
    _this.setDataCallback = _this.setDataCallback.bind((0, _assertThisInitialized2.default)(_this));
    _this.hideWidget = _this.hideWidget.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      isVoted: false,
      isDismissed: false,
      animationClass: ''
    };
    return _this;
  }

  (0, _createClass2.default)(ContentHelpfulnessPreview, [{
    key: "hideWidget",
    value: function hideWidget() {
      var _this2 = this;

      this.setState({
        animationClass: 'easy-out'
      }, function () {
        window.setTimeout(function () {
          _this2.setState({
            isDismissed: true,
            animationClass: ''
          });
        }, 300);
      });
    }
  }, {
    key: "setDataCallback",
    value: function setDataCallback() {
      var _this3 = this;

      this.setState({
        isVoted: true
      }, function () {
        window.setTimeout(function () {
          _this3.setState({
            isVoted: false
          });
        }, 3000);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var state = this.state;
      return (0, _preact.h)("div", {
        className: "content-helpfulness_preview-container"
      }, (0, _preact.h)("div", {
        className: "content-helpfulness_preview-widget-container"
      }, (0, _preact.h)("div", {
        className: "content-helpfulness_preview-title"
      }, "Topic preview"), (0, _preact.h)("div", {
        className: "content-helpfulness_preview-description"
      }, "This section is attached at the bottom of the first post"), (0, _preact.h)(_topicHelpfulness.default, {
        showIndicator: props.showIndicator,
        setData: this.setDataCallback,
        isVoted: state.isVoted,
        indicatorPercentage: 80,
        phrases: props.phrases
      })), (0, _preact.h)("div", {
        className: "content-helpfulness_preview-floating-container"
      }, (0, _preact.h)("div", {
        className: "content-helpfulness_preview-title"
      }, "Bottom bar preview"), (0, _preact.h)("div", {
        className: "content-helpfulness_preview-description"
      }, "This bottom bar will slide in when user scrolls past the first post"), (0, _preact.h)(_topicHelpfulness.default, {
        isSticky: true,
        setData: this.setDataCallback,
        hideWidget: this.hideWidget,
        animationClass: state.animationClass,
        isDismissed: state.isDismissed,
        showIndicator: props.showIndicator,
        indicatorPercentage: 80,
        isVoted: state.isVoted,
        phrases: props.phrases
      })));
    }
  }]);
  return ContentHelpfulnessPreview;
}(_preact.Component);

exports.ContentHelpfulnessPreview = ContentHelpfulnessPreview;
var _default = ContentHelpfulnessPreview;
exports.default = _default;